import Vue from 'vue'
import MetaInfo from 'vue-meta-info'

Vue.use(MetaInfo)
